import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

async function recordWeather() {
    let response = {}

    try {
        response = await axios.get(`${config.eastCoastMonitorApi()}Weather/RecordWeather`)

    } catch (err) {
        console.error('iisi recordWeather: ', err)
    }

    Utils.setApiResponsSuccess(response)
    return response
    
}

export async function getAllWeatherFromDB(condition = {}) {
    let response = {}

    try {
        response = await axios.get(`${config.eastCoastMonitorApi()}Weather/GetAllWeatherFromDB`)

    } catch (err) {
        console.error('iisi getAllWeatherFromDB: ', err)
        return
    }

    return response.data
}

export async function getWeatherFromDB(condition = {}) {
    if(Utils.isEmptyObject(condition.id)) {
        console.error('iisi getWeatherFromDB: scenicAreaId is null')
        return 
    }

    let response = {}
    let scenicAreaId = condition.id
    let scenicAreaIdQuery = `?scenicAreaId=${scenicAreaId}`
    try {
        response = await axios.get(`${config.eastCoastMonitorApi()}Weather/GetWeatherFromDB${scenicAreaIdQuery}`)

    } catch (err) {
        console.error('iisi getWeatherFromDB: ', err)
        return
    }
    
    return response.data
}